import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { RioWebClientViewProperties } from '@chegg/rio-grpc-interfaces-web-client/dist/generated/webevent/rio_web_client_view_properties_pb';
import { LS_VIEW, LS_VIEW_PREVIOUS, LS_VIEW_PREVIOUS_V1 } from '../types';
import { ls, noWindow } from '../utils';
import GrpcRioClient from '../client';
var EnrichViewProperties = /*#__PURE__*/_createClass(function EnrichViewProperties(name, value) {
  var _this = this;
  _classCallCheck(this, EnrichViewProperties);
  _defineProperty(this, "name", void 0);
  _defineProperty(this, "value", void 0);
  _defineProperty(this, "update", function (updatedCurrentView) {
    var _this$value;
    // updatedCurrentView will only be empty when enrichs are initialised
    if (!updatedCurrentView) {
      var lsViewCurrent = ls.getItem(LS_VIEW);
      var lsViewPrevious = ls.getItem(LS_VIEW_PREVIOUS);
      var lsViewPreviousV1 = ls.getItem(LS_VIEW_PREVIOUS_V1);
      if (!lsViewCurrent && !lsViewPrevious && !lsViewPreviousV1) return;
      if (GrpcRioClient.isLastSessionActive) {
        if (lsViewCurrent) {
          _this.updateView(lsViewCurrent);
        }
        if (lsViewPrevious) {
          _this.updateView(lsViewPrevious);
        } else if (lsViewPreviousV1) {
          // fetch view previous from RSW 1.0
          var viewPreviousV1 = {
            previousViewExperience: lsViewPreviousV1.experience,
            previousViewFeature: lsViewPreviousV1.feature,
            previousViewName: lsViewPreviousV1.view_name,
            previousViewProperty: lsViewPreviousV1.property
          };
          _this.updateView(viewPreviousV1, LS_VIEW_PREVIOUS);
        }
      }
      if (!noWindow() && window.viewCurrent) {
        _this.update(window.viewCurrent);
        // once consumer, removen from window
        window.viewCurrent = undefined;
      }
      return;
    }
    var updatedViewPrevious = {};

    // Check if current view exist then only update view_previous with it
    if ((_this$value = _this.value) !== null && _this$value !== void 0 && _this$value.viewExperience) {
      updatedViewPrevious = {
        previousViewExperience: _this.value.viewExperience,
        previousViewName: _this.value.viewName,
        previousViewFeature: _this.value.viewFeature,
        previousViewProperty: _this.value.viewProperty
      };
      ls.setItem(LS_VIEW_PREVIOUS, updatedViewPrevious);
    }
    if (GrpcRioClient.isLastSessionActive) {
      ls.setItem(LS_VIEW, updatedCurrentView);
    }
    _this.updateView(_objectSpread(_objectSpread({}, updatedCurrentView), updatedViewPrevious));
  });
  _defineProperty(this, "updateView", function (view, key) {
    if (key) ls.setItem(key, view);
    _this.value = _objectSpread(_objectSpread({}, _this.value), view);
  });
  _defineProperty(this, "getEnrichValue", function () {
    var rioWebClientViewProperties = new RioWebClientViewProperties();
    if (!_this.value) return undefined;
    rioWebClientViewProperties.setViewExperience(String(_this.value.viewExperience));
    rioWebClientViewProperties.setViewName(String(_this.value.viewName));
    _this.value.viewFeature && rioWebClientViewProperties.setViewFeature(String(_this.value.viewFeature));
    rioWebClientViewProperties.setViewProperty(String(_this.value.viewProperty));
    _this.value.viewVersion && rioWebClientViewProperties.setViewVersion(String(_this.value.viewVersion));
    rioWebClientViewProperties.setPreviousViewExperience(String(_this.value.previousViewExperience));
    rioWebClientViewProperties.setPreviousViewName(String(_this.value.previousViewName));
    _this.value.previousViewFeature && rioWebClientViewProperties.setPreviousViewFeature(String(_this.value.previousViewFeature));
    rioWebClientViewProperties.setPreviousViewProperty(String(_this.value.previousViewProperty));
    return rioWebClientViewProperties;
  });
  this.name = name;

  // checking if view is passed while initialisation
  if (value !== undefined) {
    this.value = _objectSpread({}, value);
  }
});
export { EnrichViewProperties as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio2-web-client/dist/esm/enrich/enrichViewProperties.js
// module id = 4154
// module chunks = 11